export const styles = {
  modal: {
    borderRadius: "16px",
    maxWidth: "340px",
  },
  title: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "16px",
  },
  content: {
    alignItems: "center",
    textAlign: "center",
    padding: "16px",
  },
};
